export default __webpack_public_path__ + "static/media/full-page-bg.31a6ab3a.jpg";